import {Key} from 'react'

import {useDispatch} from 'react-redux'
import saveAs from 'file-saver'

import {useFetchHook} from '@/hooks/useFetch'
import {setToastMessage} from '@/redux/toast-message/toast-actions'
import {exportBRfile} from '@/modules/ITSM/api/exportRequests'
import {exportType} from '@/constants'

export const useExportBillingReports = () => {
  const dispatch = useDispatch()
  const {
    handleRequested,
    handleSuccess,
    handleFail,
    handleReset,
  } = useFetchHook()

  const exportBillingReports = async (
    format: string,
    selectedRowKeys?: Array<Key>
  ) => {
    try {
      handleRequested()

      const billingReports = selectedRowKeys?.map(uuid => ({
        uuid,
      }))

      const {body} = await exportBRfile(
        format,
        billingReports?.length
          ? {
              selector: {$or: billingReports},
            }
          : {}
      )
      const fileType = format === 'xlsx' ? exportType : 'text/csv'
      const fileName =
        format === 'xlsx' ? 'billing_report.xlsx' : 'billing_report.csv'
      const file = new Blob([body], {type: fileType})
      saveAs(file, fileName)

      handleSuccess()
    } catch (err) {
      handleFail(err)
      dispatch(setToastMessage({message: err}))
    } finally {
      handleReset()
    }
  }

  return {exportBillingReports}
}
